"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function (theme) {
  return {
    sideBar: {
      textAlign: 'center',
      marginTop: theme.spacing(5)
    },
    dialog: {
      minWidth: '80vw',
      maxWidth: '95vw'
    },
    library: {
      background: theme.palette.background.paper,
      paddingBottom: theme.spacing(5),
      minHeight: '100%'
    },
    mirador: {
      height: '80vh !important'
    }
  };
});
exports.default = useStyles;